import { useCallback, useEffect, useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import { attachmentsQueryKeys, showAttachment } from 'services/api/attachments';

export function useClickAttachment(attachmentId: string) {
  const [attachmentToFetchId, setAttachmentToFetchId] = useState<string>('');

  const {
    data: attachmentData,
    isStale,
    refetch,
  } = useQuery({
    queryKey: attachmentsQueryKeys.show(attachmentToFetchId),
    queryFn: () => showAttachment({ id: attachmentToFetchId, include: 'url', viewOnly: true }),
    enabled: !!attachmentToFetchId,
    staleTime: 29 * 1000, // Attachment URL is valid for 30 seconds
  });

  const openAttachment = useCallback(() => {
    if (isStale) {
      refetch();
    } else if (attachmentData?.url) {
      window.open(attachmentData?.url, '_blank');
    } else {
      setAttachmentToFetchId(attachmentId);
    }
  }, [attachmentId, isStale, attachmentData?.url, refetch]);

  useEffect(() => {
    if (attachmentData?.url) {
      window.open(attachmentData?.url, '_blank');
    }
  }, [attachmentData?.url]);

  return openAttachment;
}
